import React, { useState } from 'react';

export default function TestSimplePanel() {
  const [showPanel, setShowPanel] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Simple Panel Test</h1>
        
        <button
          onClick={() => setShowPanel(!showPanel)}
          className="px-4 py-2 bg-amber-600 text-white rounded hover:bg-amber-700"
        >
          Toggle Panel
        </button>
        
        {showPanel && (
          <div className="mt-4 p-4 bg-white rounded-lg shadow">
            <h2 className="text-lg font-semibold mb-2">Panel Content</h2>
            <p>This is a simple test to verify routing works.</p>
          </div>
        )}
        
        <div className="mt-8 p-4 bg-blue-50 rounded">
          <p>If you can see this page, the routing is working correctly.</p>
          <p>Next step: Test importing the TaskSidePanel component.</p>
        </div>
      </div>
    </div>
  );
}